<template>
  <div>
    <div v-if="!goalsList.length && !dirty"
         class="text-xl font-bold text-text leading-tight text-center">
      {{ $t('noGoals') }}
    </div>
    <template v-else>
      <div class="grid grid-cols-2 lg:grid-cols-3 col-gap-12 row-gap-12 mb-12"
           v-if="listStructureId === 0">
        <GoalTile v-for="(goal,i) in goalsOngoing" :key="`${i}`"
                  v-bind="goal"
                  @click.native="openGoalModal(goal)"></GoalTile>
      </div>
      <template v-else v-for="(goalGroup,i) in goalsGrouped">
        <template v-if="goalGroup.goalsList.length">
          <div class="text-xl font-bold text-text leading-tight mb-8">{{ goalGroup.title }}</div>
          <div class="grid grid-cols-2 lg:grid-cols-3 col-gap-12 row-gap-12 mb-12" :key="`goal-group-${i}`">
            <GoalTile v-for="(goal,i) in goalGroup.goalsList" :key="`${i}`"
                      v-bind="goal"
                      @click.native="openGoalModal(goal)"></GoalTile>
          </div>
        </template>
      </template>
      <template v-if="showFinished && finishedGoals.length">
        <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('finishedGoalsTitle') }}</div>
        <div class="grid grid-cols-2 lg:grid-cols-3 col-gap-12 row-gap-12 mb-12">
          <GoalTile v-for="(goal,i) in finishedGoals" :key="`${i}`"
                    v-bind="goal"
                    @click.native="openGoalModal(goal)"></GoalTile>
        </div>
      </template>
    </template>
    <GoalPreviewModal v-if="!!previewGoal"
                      :goal="previewGoal"
                      @edit-goal="openEditGoalModal"
                      @close="closePreviewModal"/>
    <GoalEditModal v-if="!!editGoal"
                   :edit-goal="editGoal"
                   @saved="finishEditModal($event)"
                   @close="cancelEditGoal"/>
  </div>
</template>

<script>
import GoalTile from "@/components/cabinet/Money/Goals/GoalTile";
import GoalPreviewModal from "@/components/cabinet/Money/Goals/GoalPreview/GoalPreviewModal";
import GoalEditModal from "@/components/cabinet/Money/Goals/GoalEdit/GoalEditModal";
import {mapGetters} from "vuex";

export default {
  name: "GoalsList",
  props: {
    goalsList: {
      type: Array
    },
    listStructureId: {
      type: Number
    },
    showFinished: {
      type: Boolean,
    },
    dirty: {
      type: Boolean,
      default: false
    }
  },
  components: {GoalEditModal, GoalPreviewModal, GoalTile},
  data() {
    return {
      previewGoal: null,
      editGoal: null
    }
  },
  computed: {
    ...mapGetters('space/goals', ['goalTypeList']),
    goalsOngoing() {
      return [...this.goalsList].filter(item => item.status !== 2)
    },
    goalsGrouped() {
      let goalsOngoing = this.goalsOngoing,
          goalsList;
      switch (this.listStructureId) {
        case 1:
          goalsList = this.goalTypeList.map((type) => ({
            title: type[`name_${this.$i18n.locale}`],
            goalsList: goalsOngoing.filter(item => item.goal_type === type.id)
          }))
          break;
        case 2:
          goalsList = {};
          goalsOngoing.forEach((item) => {
            let goalYear = this.$moment.unix(item.goal_date_end).format('YYYY');
            if (Object.keys(goalsList).includes(goalYear)) {
              goalsList[goalYear].goalsList.push(item);
            } else {
              goalsList[goalYear] = {title: goalYear, goalsList: [item]}
            }
          })
          break;
        case 0:
        default:
          goalsList = this.goalsList;
          break;
      }
      return goalsList;
    },
    finishedGoals() {
      return [...this.goalsList].filter(item => item.status === 2)
    },
  },
  methods: {
    openGoalModal(goal) {
      this.previewGoal = goal;
    },
    closePreviewModal() {
      this.previewGoal = null;
    },
    openEditGoalModal() {
      this.editGoal = this.previewGoal;
      this.previewGoal = null;
    },
    cancelEditGoal() {
      this.previewGoal = this.editGoal;
      this.editGoal = null;
    },
    finishEditModal(goal) {
      this.previewGoal = goal;
      this.editGoal = null;
    }
  },
  i18n: {
    messages: {
      en: {
        finishedGoalsTitle: 'Finished goals',
        noGoals: 'No goals added'
      },
      ru: {
        finishedGoalsTitle: 'Завершенные цели',
        noGoals: 'Нет целей'
      },
    }
  }
}
</script>